import React from "react";
import { CtaButton } from "../CtaButton";
import { ContentIcon } from "../ContentIcon";
import { Countdown } from "../Countdown";
import { finalIncludes } from "../../data/content";
import { MOCKUP_URL } from "../../data/offer";
export function FinalCta() {
  return <section className="bg-navy px-4 py-16 sm:py-20" data-id="element-179" data-mp="1so2tgmc2kock">
      <div className="mx-auto max-w-3xl text-center" data-id="element-180" data-mp="1smroij6w1ajv">
        <p className="text-sm font-black uppercase tracking-wide text-sun" data-id="element-181" data-mp="1eojmhwuzvj1u">
          Ready to organize your communication support planning?
        </p>
        <h2 className="mt-3 text-balance text-[1.9rem] font-black leading-[1.12] text-white sm:text-4xl" data-id="element-182" data-mp="1irg8zynnnzb2">
          Stop Rebuilding Every Worksheet, Visual Support, and Planning Document From Scratch.
        </h2>
        <p className="mt-4 text-lg font-semibold leading-relaxed text-white/80" data-id="element-183" data-mp="19rb2rru776yh">
          Start With a Structured Educational Collection Designed Around Real Communication Support Needs.
        </p>
        <p className="mt-4 text-base font-semibold leading-relaxed text-white/70" data-id="element-184" data-mp="341599f6ch9vo">
          You already understand how important meaningful communication is. Now you can bring your planning
          resources together in one organized place.
        </p>

        <img src={MOCKUP_URL} alt="Complete Blueprint collection" className="mx-auto mt-8 w-full max-w-xl" data-id="element-185" data-mp="b0dj4dm6tw86" />

        <div className="mt-8 rounded-3xl bg-white p-5 text-left sm:p-8" data-id="element-186" data-mp="714rbeapk8f9">
          <p className="text-center text-lg font-black uppercase text-navy" data-id="element-187" data-mp="3ff4z88av8plo">Your complete collection includes:</p>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-188" data-mp="3ahlmjcttgkvu">
            {finalIncludes.map(item => <li key={item.label} className="flex items-center gap-3" data-id="element-189" data-mp="3ohebb2ls8r16">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-soft text-brand" data-id="element-190" data-mp="3jgqkoi1guc7h">
                  <ContentIcon name={item.icon} className="h-5 w-5" data-id="element-191" data-mp="13p2qgudu6xsd" />
                </span>
                <span className="text-[15px] font-extrabold leading-snug text-navy" data-id="element-192" data-mp="yrssurganftg">{item.label}</span>
              </li>)}
          </ul>
          <div className="mt-6 border-t border-line pt-5 text-center" data-id="element-193" data-mp="3sl3lf7bu3013">
            <p className="text-sm font-black uppercase text-ink/60" data-id="element-194" data-mp="1b4rme97dgw3">
              Total suggested reference value: <span className="text-coral line-through" data-id="element-195" data-mp="5eszyz5nsgie">$203</span>
            </p>
            <p className="mt-1 text-lg font-black uppercase text-navy" data-id="element-196" data-mp="acb8wpjoevqe">Your price today:</p>
            <p className="text-7xl font-black leading-none text-cta" data-id="element-197" data-mp="39tj2yy5f081e">
              $27<span className="ml-1 align-top text-2xl text-navy" data-id="element-198" data-mp="3dtthiz79w6rv">USD</span>
            </p>
          </div>
          <div className="mt-7" data-id="element-199" data-mp="3isnydvlojl9c">
            <CtaButton label="Yes! I want Autism Communication Support Blueprint™ now" sub="One-Time Payment · Instant Digital Access · Lifetime Access to Purchased Materials" data-id="element-200" data-mp="3iseb4fs0rs7c" />
          </div>
          <div className="mt-7" data-id="element-201" data-mp="2q2o38ogzdmjo">
            <Countdown label="Introductory offer ends in:" data-id="element-202" data-mp="2v33ixmoqj64t" />
          </div>
        </div>
      </div>
    </section>;
}